import { ErrorHandler, Injectable, NgZone } from '@angular/core';
import { SnackbarService } from './snackbar.sevice';
import { Constants } from '../models/constants';
import { HttpErrorResponse } from '@angular/common/http';
import { OnlineStatusHandler } from './online.status.handler';
import { AuthenticationService, PermissionError } from '../authentication/services/authentication.service';
import { ApiException } from '../api-module/control-centre-api-client';

@Injectable()
export class AppErrorHandler implements ErrorHandler {
    constructor(
        private readonly ngZone: NgZone,
        private readonly snackbarService: SnackbarService,
        private readonly authenticationService: AuthenticationService,
        private readonly onlineStatusHandler: OnlineStatusHandler
    ) {}

    handleError(error): void {
        const that = this;
        if (error.promise && error.rejection) {
            error = error.rejection;
        }

        console.error(error);
        this.ngZone.run(() => {
            if (error instanceof HttpErrorResponse || ApiException.isApiException(error)) {
                if (this.onlineStatusHandler.isOnline) {
                    that.snackbarService.openSnackBar(Constants.UnableToContactServerMessage, SnackbarService.SNACK_BAR_CLASS_ALERT);
                }
                // If it's offline, then don't show the error message. The AppComponent should have shown an error.
            }
            if (error instanceof PermissionError) {
                console.error('Invalid permission detected', null, error);
                switch ((error as PermissionError).type) {
                    case 'no_org':
                        that.authenticationService.configureOAuthServiceLogoutUrlWithMessage(Constants.UserPermissionError);
                        break;
                    default:
                        that.authenticationService.configureOAuthServiceLogoutUrlWithMessage(Constants.UserSettingError);
                        break;
                }

                that.authenticationService.doLogout();
            } else {
                // Generally, log should be sent from here to somewhere.
                console.error(error);
            }
        });
    }
}
